export type EstateQrSpeechRecognitionConstructor = new () => EstateQrSpeechRecognition;

export type EstateQrSpeechRecognition = {
  continuous: boolean;
  interimResults: boolean;
  lang: string;
  onresult: ((event: EstateQrSpeechRecognitionEvent) => void) | null;
  onerror: ((event: EstateQrSpeechRecognitionErrorEvent) => void) | null;
  onend: (() => void) | null;
  start(): void;
  stop(): void;
};

export type EstateQrSpeechRecognitionEvent = {
  resultIndex: number;
  results: ArrayLike<EstateQrSpeechRecognitionResult>;
};

type EstateQrSpeechRecognitionResult = ArrayLike<EstateQrSpeechRecognitionAlternative> & {
  isFinal: boolean;
};

type EstateQrSpeechRecognitionAlternative = {
  transcript: string;
};

export type EstateQrSpeechRecognitionErrorEvent = {
  error: string;
};

type EstateQrSpeechRecognitionWindow = Window &
  typeof globalThis & {
    SpeechRecognition?: EstateQrSpeechRecognitionConstructor;
    webkitSpeechRecognition?: EstateQrSpeechRecognitionConstructor;
  };

export function getEstateQrSpeechRecognitionConstructor(
  browserWindow: Window & typeof globalThis
): EstateQrSpeechRecognitionConstructor | null {
  const speechWindow = browserWindow as EstateQrSpeechRecognitionWindow;
  return speechWindow.SpeechRecognition ?? speechWindow.webkitSpeechRecognition ?? null;
}

export function collectEstateQrSpeechRecognitionTranscripts(event: EstateQrSpeechRecognitionEvent): string[] {
  const transcripts: string[] = [];

  for (let index = event.resultIndex; index < event.results.length; index += 1) {
    const result = event.results[index];
    const transcript = result?.[0]?.transcript?.trim();

    if (result?.isFinal && transcript) {
      transcripts.push(transcript);
    }
  }

  return transcripts;
}

export function getEstateQrSpeechRecognitionErrorKey(error: string): string {
  switch (error) {
    case 'not-allowed':
    case 'service-not-allowed':
      return 'estate.qrPublicSpeechErrorMicrophoneAccess';
    case 'no-speech':
      return 'estate.qrPublicSpeechErrorNoSpeech';
    case 'audio-capture':
      return 'estate.qrPublicSpeechErrorAudioCapture';
    case 'network':
      return 'estate.qrPublicSpeechErrorNetwork';
    default:
      return 'estate.qrPublicSpeechErrorUnknown';
  }
}
